import { render, staticRenderFns } from "./ProfilePageContainer.vue?vue&type=template&id=cd6f9308&"
import script from "./ProfilePageContainer.vue?vue&type=script&lang=js&"
export * from "./ProfilePageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports